import authInstance from "../utilities/axios/authInstance";

export const allCities = () => authInstance.get('cities');

export const oneCity = (id) => authInstance.get('cities/' + id);

export const addCity = (city) => authInstance.post('cities', city);

export const updateCity = (id, city) => authInstance.put('cities/' + id, city);

export const removeCity = (id) => authInstance.delete('cities/' + id);

export const searchCities = (city) => authInstance.get('search/cities', {
    params: {
        name: city
    }
});